import {Routes} from "@angular/router";
import {AuthenticationGuard} from "@app/core/guards/authentication/authentication.guard";
import {LogoutGuard} from "@app/core/guards/logout.guard";
import {RoleGuard} from "@app/core/guards/role.guard";
import {AdminMainComponent} from "@app/manager/admin-main/admin-main.component";
import {AdminAccountComponent} from "@app/features/admins/components/admin-account/admin-account.component";

import {RoleEnum} from "@app/core/models/java.model";

export const routes: Routes = [
  {
    path: 'authentication',
    loadChildren: () => import('./authentication/authentication.route').then(m => m.routes),
    canActivate: [LogoutGuard],
    title: 'Authentification'
  },

  {
    path: 'muslim-market',
    loadChildren: () => import('./guest/guest.route').then(m => m.routes),
    title: 'Muslim Shoco'
  },
  {
    path: 'account',
    canActivate: [AuthenticationGuard],
    data: {role: RoleEnum.CUSTOMER},
    loadChildren: () => import('./client/unified-account/unified-account.route').then(m => m.routes),
    title: 'Mon compte'
  },

  {
    path: 'administration',
    component: AdminMainComponent,
    canActivate: [AuthenticationGuard, RoleGuard],
    data: {role: RoleEnum.ADMIN},
    title: 'Administration',
    children: [
      {
        path: 'management',
        loadChildren: ()=>import('./manager/manager.route').then(m=>m.routes),
        canActivate: [RoleGuard],
        data: {role: RoleEnum.ADMIN},
      },
     /* {
        path: 'users',
        loadChildren: () => import('./features/users/user.route').then(m => m.routes),
        canActivate: [RoleGuard],
        data: {role: RoleEnum.ADMIN},
        title: 'Gestion des utilisateurs'
      },*/
      {
        path: 'advertisements',
        loadChildren: () => import('@manager/marketing/advertisement/advertisement.route').then(m => m.routes),
        canActivate: [AuthenticationGuard, RoleGuard],
        data: {role: RoleEnum.ADMIN},
        title: 'Gestion des publicités'
      },
      {
        path: 'deliveries',
        loadChildren: () => import('@manager/commerce/deliveries/delivery.route').then(m => m.routes),
        canActivate: [RoleGuard],
        data: {role: RoleEnum.ADMIN},
        title: 'Gestion des livraisons'
      },
      {
        path: 'account',
        component: AdminAccountComponent,
        canActivate: [RoleGuard],
        data: {role: RoleEnum.ADMIN},
        title: 'Compte administrateur'
      },
      {
        path: 'analytics',
        loadComponent: () => import('./features/analytics/analytics-dashboard/analytics-dashboard.component')
          .then(c => c.AnalyticsDashboardComponent),
        canActivate: [RoleGuard],
        data: {role: RoleEnum.ADMIN},
        title: 'Rapports & Analytics'
      },
      {
        path: 'content',
        loadChildren: () => import('@manager/marketing/page-section/page-section.route').then(m => m.routes),
        canActivate: [RoleGuard],
        data: {role: RoleEnum.ADMIN},
        title: 'Gestion de Contenu'
      }
    ]
  },
  {
    path: '',
    redirectTo: '/muslim-market',
    pathMatch: "full"
  },
  {
    path: '**',
    loadChildren: () => import('./pages/error/error.route').then(m => m.routes),
    title: 'Page non trouvée'
  }
];
